// extracted by mini-css-extract-plugin
module.exports = {"body":"MapPage_body__2WADm","summary":"MapPage_summary__1Rkee","summaryTitle":"MapPage_summaryTitle__1Nart","details":"MapPage_details__1z6UO"};